import { useAuthManagerStore } from "../../../core/services/stores/authManagerStore/store";
import { ClaimEnum } from "../../enums/claim";
export function checkPermissions(claim) {
    var _a;
    try {
        var permissions = ((_a = useAuthManagerStore === null || useAuthManagerStore === void 0 ? void 0 : useAuthManagerStore.getState()) === null || _a === void 0 ? void 0 : _a.permissions) || [];
        if (permissions.includes(ClaimEnum.CanAll)) {
            return true;
        }
        return permissions.includes(claim);
    }
    catch (error) {
        console.error("claim check error:", error);
        return false;
    }
}
